import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { isPlatformBrowser, Location } from '@angular/common';

import { languages } from '../../shared/constants/app-enums';
import { EventService } from '../../services/event.service';
import { WalletConnectService } from '../../services/wallet-connect.service';
import { ConnectComponent } from '../../modals/connect/connect.component';
import { language } from '../../shared/interfaces/wallet.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @ViewChild('navigation') navigation!: ElementRef;
  subscription!: Subscription;
  isScrolled: boolean = false;
  showMenu: boolean = false;
  openMenu: boolean = false;
  modalRef?: BsModalRef;
  hashKey: string = '';
  currentLanguage = '';
  languagesList = languages;
  selectedLanguage: language = {} as language;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isScrolled = window.pageYOffset >= 50;
  }

  resourceSubMenu = [
    {
      routeName: '',
      externalLink:"https://apply.pepeunchained.com/form",
      navName: 'top_navigation.subnav_resource_1',
    },
    {
      routeName: '',
      externalLink:"https://guide.pepeunchained.com/",
      navName: 'top_navigation.subnav_resource_2',
    },
    {
      routeName: '',
      externalLink:" https://mirror.xyz/0x5d229f641ccA8c85F356a29A2b5D12587a216Fd2",
      navName: 'top_navigation.subnav_resource_3',
    },
    {
      routeName: '',
      navName: 'top_navigation.subnav_resource_4',
    },
    {
      routeName: '',
      navName: 'top_navigation.subnav_resource_5',
    },
  ];

  productSubMenu = [
    {
      routeName: '',
      navName: 'top_navigation.subnav_product_1',
    },
    {
      routeName: '',
      navName: 'top_navigation.subnav_product_2',
    },
  ];

 
  social = [
    {
      img: 'assets/images/svg-icons/social-icons/twitter.svg',
      alt: 'Twitter',
      link: 'https://x.com/pepe_unchained',
    },
    {
      img: 'assets/images/svg-icons/social-icons/telegram.svg',
      alt: 'Telegram',
      link: 'https://t.me/pepeunchn/1',
    },
  ];

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private location: Location,
    private eventService: EventService,
    private translate: TranslateService,
    private modalService: BsModalService,
    private walletConnectService: WalletConnectService,
  ) {
    this.subscription = this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      // console.log('LangChangeEvent called in header', params.lang);
      this.currentLanguage = params.lang;
      this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
      if (isPlatformBrowser(this._platformId)) localStorage.setItem('lang', this.currentLanguage);
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      if (!this.currentLanguage) {
        this.currentLanguage = localStorage.getItem('lang') || 'en';
        this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
      }

      if (window.location.hash) {
        setTimeout(() => {
          this.hashKey = window.location.hash.substring(1, window.location.hash.length);
          this.addActive(this.navigation.nativeElement, this.hashKey);
        }, 2000);
      }
    }
  }

  changeLanguage(requestLang: string): void {
    if (this.currentLanguage !== requestLang) {
      this.currentLanguage = requestLang;
      this.translate.use(this.currentLanguage);
      this.eventService.setLang(this.currentLanguage);
      this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
      this.replaceURL();
    }
  }

  replaceURL(): void {
    const current_url = this.location.path().split('/');
    current_url.shift();
    current_url.splice(0, 1, this.currentLanguage);
    const new_url = this.hashKey ? current_url.join('/') + `#${this.hashKey}` : current_url.join('/');
    this.location.go('/' + new_url);
  }

  addActive(event: Event, section: string) {
    this.hashKey = section;
    const target: any = event.currentTarget ? event.currentTarget : event;
    let linkList = target.parentNode.querySelectorAll('a');
    linkList.forEach((link: any) => {
      if (link === event.target || link.title === this.hashKey) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  get walletAddress(): string {
    return this.walletConnectService.walletAddress;
  }

  showWidget(section: string): void {
    if (window.location.pathname.includes('dashboard')) {
      window.scroll({ top: 0 });
      this.connectModal();
    } else {
      this.eventService.showBuyWidget(section);
    }
  }

  connectModal(): void {
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
    });
  }

  disconnect(): void {
    this.walletConnectService.disConnectWallet();
  }

  openCloseMenu(): void {
    if (this.showMenu) {
      this.openMenu = !this.openMenu;
      setTimeout(() => (this.showMenu = !this.showMenu), 600);
    } else {
      this.showMenu = !this.showMenu;
      setTimeout(() => (this.openMenu = !this.openMenu), 300);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  redirectToExternalLink(link:string | undefined) {
    if(isPlatformBrowser(this._platformId) && link) {
      window.open(link , "_blank")
    }
  }
}
